module.exports = __webpack_public_path__ + "img/9-2.10c2388d.jpg";